const state = () => ({
  siteId: null,
  userId: null,
  expiresInDays: null,
})

const getters = {
  siteId: state => state.siteId,
  userId: state => state.userId,
  userIdExpiresInDays: state => state.expiresInDays,
}

const mutations = {
  setSiteId (state, value) {
    state.siteId = value
  },
  setUserId (state, value) {
    state.userId = value
  },
  setCookieEndDate (state, value) {
    const end = this.$moment(value)
    const now = this.$moment()
    const days = end.diff(now, 'days')
    state.expiresInDays = days
  },
}

const actions = {
  saveCookieInStore ({ commit }, cookie) {
    if (!cookie.length) {
      return
    }
    if (typeof cookie === 'string') {
      cookie = JSON.parse(cookie)
    }
    if (cookie.val) {
      commit('setUserId', cookie.val)
    }
    if (cookie.options && cookie.options.end) {
      commit('setCookieEndDate', cookie.options.end)
    }
  },
  setSiteId ({ commit }, value) {
    commit('setSiteId', value)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
